<template>
  <session class="page-video-intros">
    <div class="video-intros-item" v-for="item in list" :key="item.id">
      <div class="video-intros-item-cover">
        <MyVideo :src="item.path" :poster="item.coverUrl" />
      </div>
      <div class="video-intros-item-title">
        {{ item.name }}
      </div>
    </div>
    <!-- <MyVideo v-if="showVideo" :src="item.path" /> -->
  </session>
</template>

<script setup>
  import { onMounted, ref } from 'vue';
  import { useRouter, useRoute } from 'vue-router';
  const route = useRoute();
  import MyVideo from '@/components/myvideo/index.vue';

  import * as Request from '@/assets/request'

  const list = ref([])
  const getList = async () => {
    const result = await Request.get({
      url: '/api/v1/intro/videos',
    })
    list.value = result?.data?.list || []
    console.log(list.value)
  }
  onMounted(() => {
    getList()
  })

  // 点击开始播放视频
  const startPlayVideo = (item) => {
    
  }
</script>

<style scoped lang="less">
@import "index.less";
</style>
